export const ON_ERROR = 'ON_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const ON_RECEIVE_COUNT = 'ON_RECEIVE_COUNT';
export const ON_RECEIVE_HAS_MORE = 'ON_RECEIVE_HAS_MORE';



// WEBPACK FOOTER //
// ./src/modules/app_state/action_types.js